/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TemplateFileType } from '../models/TemplateFileType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TemplateFilesService {

    /**
     * Download CSV template file
     * @returns binary Success
     * @throws ApiError
     */
    public static downloadTemplate({
        fileType,
    }: {
        /**
         * File Type
         */
        fileType: TemplateFileType,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/templateFile/{fileType}',
            path: {
                'fileType': fileType,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
